/**
 * De dónde cuelga el BFF del backoffice.
 *
 * El login de una superficie de plataforma necesita un servidor confidencial
 * que ponga la app y el contexto: es el BFF que vive en el backend de Fisto
 * (`backend/src/api/bo/`). La sesión es una cookie, así que el BFF y el CRUD
 * tienen que estar en el MISMO origen: todo se deriva del prefijo `/api`, que
 * el proxy (Vite en local, Caddy en QA/prod) reescribe al backend.
 */
const API_PREFIX = '/api';

/** Absoluto y same-origin: RIA valida que la base sea una URL absoluta. */
export function getApiBaseUrl(): string {
  return new URL(API_PREFIX, window.location.origin).toString().replace(/\/+$/, '');
}

/** El BFF y el CRUD del backoffice cuelgan del mismo prefijo, un nivel adentro. */
export function getBoBaseUrl(): string {
  return `${getApiBaseUrl()}/bo`;
}
